// import CryptoJS from 'crypto-js';
var axios = require("axios");
const contentful = require("contentful");

const getNewsData = (isDevContent = false, username = '', password = '') => {
    // const passphrase = "NRGPasswordProtect";
    // var encrypted = CryptoJS.AES.encrypt(password, passphrase);
    
    // var decrypted = CryptoJS.AES.decrypt(encrypted.toString(), passphrase);
    // console.log(decrypted);
    // console.log(decrypted.toString(CryptoJS.enc.Utf8));

    return new Promise((resolve, reject) => {
        let url = "https://knpgmabrpi.execute-api.us-west-2.amazonaws.com/Prod/get?" +  (isDevContent ? "isDevContent=" + isDevContent : '') +
            // "&username=nrg" + "&password=stagwelltech";
            (username ? "&username=" + username : '' ) + (password ? "&password=" + password : '');
        
        axios.get(url)
            .then((entries) => {
                // console.log("entries");
                // console.log(entries);
                if (entries && entries.data) {
                    resolve(entries.data);
                }
            })
            .catch((err) => {
                reject(err);
            })
    })
}

const getPeopleBioData = (isDevContent = false, username = '', password = '') => {
    // return new Promise((resolve, reject) => {
    //     var contentfulClient = contentful.createClient(isDevContent ? {
    //         accessToken: '2272acca595be9c4d4f08bacd8339fc188ae63242753345099205e82445bf99e',
    //         space: 'pqc596u2kvz0',
    //         host: "preview.contentful.com"
    //     }
    //         :
    //         {
    //             accessToken: '81159f7179de42261f22ca42b3e2d566a21168da1c781f75106171ac1bbb8a7d',
    //             space: 'pqc596u2kvz0',
    //         })

    //     contentfulClient
    //         .getEntries({
    //             content_type: "peopleTeam",
    //             include: 3
    //         })
    //         .then((entries) => {
    //             resolve(entries);
    //         })
    //         .catch((err) => {
    //             reject(err);
    //         })
    // });

    // return new Promise((resolve, reject) => {
    //     let url = "https://vb84indpz0.execute-api.us-east-1.amazonaws.com/Prod?" + "sectionType=peopleprofiles"  +  (isDevContent ? "&isDevContent=" + isDevContent : '') +
    //         "&username=nrg" + "&password=stagwelltech";
    //         // (username ? "&username=" + username : '' ) + (password ? "&password=" + password : '');
        
    //     axios.get(url)
    //         .then((entries) => {
    //             console.log("entries");
    //             console.log(entries);
    //             if (entries && entries.data) {
    //                 resolve(entries.data);
    //             }
    //         })
    //         .catch((err) => {
    //             reject(err);
    //         })
    // })
}

export { getNewsData, getPeopleBioData };
